import { useEffect, useState } from 'react';
import './App.css';
import CtCompromisso from './graficos/compromissos';
import CtTituloVenc from './graficos/titulos-vencidos';
import CtContaCxBca from './graficos/contas';
import CtConsolidado from './graficos/fluxo-caixa';
import CtVendasDiaria from './graficos/vendas';
import { Row, Col, Card, Typography } from 'antd';
import { proximaSextaFeira } from './functions/funcoes';
import { ConfigProvider } from 'antd';
import pt_BR from 'antd/locale/pt_BR';
import { getHeight } from './functions/funcoes';
import { iLayoutSpan, iLayoutVisivel } from './interfaces/iLayout';
import { Azul, Fundo, Primario } from './constants/Cores';

const { Text } = Typography;

function App() {
  let [layout, setLayout] = useState<iLayoutVisivel>({
    compromisso: false,
    titulosvenc: false,
    contas: false,
    fluxocaixa: false,
    vendas: false
  });

  const [layoutSpan, setLayoutSpan] = useState<iLayoutSpan>({
    compromisso: 0,
    titulosvenc: 0,
    contas: 0,
    fluxocaixa: 0,
    vendas: 0
  });

  function SetTamanhoSpan(_ALayout: iLayoutVisivel): iLayoutSpan {
    let visiveis = Object.keys(_ALayout).filter((key) => _ALayout[key as keyof iLayoutVisivel]);
    const QtdeVisivel = visiveis.length;
    // Todos visiveis
    let Layout: iLayoutSpan = {
      compromisso: 7,
      titulosvenc: 7,
      contas: 10,
      vendas: 12,
      fluxocaixa: 12,
    };
    switch (QtdeVisivel) {
      case 4:
        if (_ALayout.fluxocaixa && !_ALayout.vendas) {
          Layout = {
            compromisso: 7,
            titulosvenc: 7,
            contas: 10,
            vendas: 0,
            fluxocaixa: 24
          }
          return Layout;
        }
        if (!_ALayout.fluxocaixa && _ALayout.vendas) {
          Layout = {
            compromisso: 7,
            titulosvenc: 7,
            contas: _ALayout.contas ? 10 : 0,
            vendas: 24,
            fluxocaixa: 0
          }
          return Layout;
        }
        if (!_ALayout.contas && _ALayout.fluxocaixa && _ALayout.vendas) {
          Layout = {
            compromisso: 7,
            titulosvenc: 7,
            contas: 0,
            vendas: 24,
            fluxocaixa: 10
          }
          return Layout;
        }
        break;
      case 3:
        if (_ALayout.compromisso && _ALayout.titulosvenc && !_ALayout.contas && !_ALayout.fluxocaixa && _ALayout.vendas) {
          Layout = {
            compromisso: 12,
            titulosvenc: 12,
            contas: 0,
            vendas: 24,
            fluxocaixa: 0
          }
          return Layout;
        }
        if (_ALayout.compromisso && _ALayout.titulosvenc && _ALayout.contas && !_ALayout.fluxocaixa && !_ALayout.vendas) {
          Layout = {
            compromisso: 7,
            titulosvenc: 7,
            contas: 10,
            vendas: 0,
            fluxocaixa: 0
          }
          return Layout;
        }
        if (_ALayout.compromisso && _ALayout.titulosvenc && !_ALayout.contas && _ALayout.fluxocaixa && !_ALayout.vendas) {
          Layout = {
            compromisso: 12,
            titulosvenc: 12,
            contas: 0,
            vendas: 0,
            fluxocaixa: 24
          }
          return Layout;
        }
        if (!_ALayout.contas && !_ALayout.fluxocaixa && _ALayout.vendas) {
          Layout = {
            compromisso: 12,
            titulosvenc: 12,
            contas: 0,
            vendas: 0,
            fluxocaixa: 24
          }
          return Layout;
        }
        if (!_ALayout.compromisso && !_ALayout.titulosvenc && _ALayout.contas && _ALayout.fluxocaixa && _ALayout.vendas) {
          Layout = {
            compromisso: 0,
            titulosvenc: 0,
            contas: 12,
            vendas: 24,
            fluxocaixa: 12
          }
          return Layout;
        }
        break;
      case 2:
        Layout = {
          compromisso: _ALayout.compromisso ? 12 : 0,
          titulosvenc: _ALayout.titulosvenc ? 12 : 0,
          contas: _ALayout.contas ? 12 : 0,
          vendas: _ALayout.vendas ? 12 : 0,
          fluxocaixa: _ALayout.fluxocaixa ? 12 : 0
        }
        return Layout;
      case 1:
          Layout = {
            compromisso: _ALayout.compromisso ? 24 : 0,
            titulosvenc: _ALayout.titulosvenc ? 24 : 0,
            contas: _ALayout.contas ? 24 : 0,
            vendas: _ALayout.vendas ? 24 : 0,
            fluxocaixa: _ALayout.fluxocaixa ? 24 : 0
          };
          return Layout;
      default: break;
    }
    return Layout;
  }

  let Gutter: [24, 24] | [24, 10] | [10 , 10] = [24, 24]
  function getGutter() {

    let AAltura = {
      A1920xL1080: 1,
      A1680xL1050: 1,
      A1600xL900: 0,
      A1440xL900: 0,
      A1400xL1050: 0,
      A1366xL768: 0,
      A1280xL1024: 0,
      A1280xL960: 0,
      A1280xL800: 0,
      A1280xL768: 0,
      A1280xL720: 0,
      A1280xL600: 0,
      A1152xL864: 0,
      A1024xL768: 0,
      A800xL600: 0,
    };
    if (getHeight(AAltura) === 1) {
      Gutter = [24, 24];
    } else {
      Gutter = [10, 10];
    }
  }

  getGutter();

  useEffect(() => {
    window.addEventListener('ajustarLayout', (event: any) => {
      let dadosRecebidos = event.detail;
      setLayout(dadosRecebidos);
      let Tamanho = SetTamanhoSpan(dadosRecebidos);
      setLayoutSpan(Tamanho);
    })
  }, []);

  return (
    <ConfigProvider
      locale={pt_BR}
      theme={{
        token: {
          colorBgBase: Fundo,
          colorPrimary: Primario,
          fontFamily: 'Comfortaa',
          colorSuccess: Azul
        },
        components: {
          Card: {
            bodyPadding: 0,
            bodyPaddingSM: 10,
          }
        }
      }}
    >
      <div className="App" style={{ padding: '0px 5px' }}>
        <br />
        <Row gutter={Gutter}>
          <Col
            span={layoutSpan.compromisso}>
            <Card
              size='small'
              variant="borderless"
              style={{cursor: 'default'}}
              hoverable>
              <Text>Compromissos até sexta-feira ({proximaSextaFeira()})</Text>
              <CtCompromisso />
            </Card>
          </Col>
          <Col span={layoutSpan.titulosvenc}>
            <Card
              size='small'
              variant="borderless"
              style={{cursor: 'default'}}
              hoverable>
              <Text>Títulos vencidos (até hoje)</Text>
              <CtTituloVenc />
            </Card>
          </Col>
          <Col span={layoutSpan.contas}>
            <Card
              size='small'
              variant="borderless"
              style={{cursor: 'default'}}
              hoverable>
              <Text>Contas</Text>
              <CtContaCxBca />
            </Card>
          </Col>
          <Col span={layoutSpan.fluxocaixa}>
            <Card
              size='small'
              variant="borderless"
              style={{cursor: 'default'}}
              hoverable>
              <Text>Fluxo de caixa (consolidado)</Text>
              <CtConsolidado />
            </Card>
          </Col>
          <Col span={layoutSpan.vendas}>
            <Card
              size='small'
              variant="borderless"
              style={{cursor: 'default'}}
              hoverable>
              <Text>Vendas diárias</Text>
              <CtVendasDiaria />
            </Card>
          </Col>
        </Row>
      </div>
    </ConfigProvider>
  );
}

export default App;
